module.exports = __webpack_public_path__ + "img/card-payment.ad34c29a.svg";